"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../api/webAApi");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var moment = require("moment");
var BrandGwsGameProviderSegmentationListCtl = /** @class */ (function (_super) {
    __extends(BrandGwsGameProviderSegmentationListCtl, _super);
    function BrandGwsGameProviderSegmentationListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        /*
        public readonly dk_treshold_rtp_type_code = UIUtils.IProp2Str((o: IBrandGwsGameProviderSegmentationListItem) => { o.treshold_rtp_type_code });
        public readonly dk_treshold_rtp_type_title = UIUtils.IProp2Str((o: IBrandGwsGameProviderSegmentationListItem) => { o.treshold_rtp_type_title });
        public readonly dk_treshold_rtp_x100 = UIUtils.IProp2Str((o: IBrandGwsGameProviderSegmentationListItem) => { o.treshold_rtp_x100 });
        public readonly dk_is_treshold_rtp = UIUtils.IProp2Str((o: IBrandGwsGameProviderSegmentationListItem) => { o.is_treshold_rtp });
    
        public readonly dk_treshold_dep_count_type_code = UIUtils.IProp2Str((o: IBrandGwsGameProviderSegmentationListItem) => { o.treshold_dep_count_type_code });
        public readonly dk_treshold_dep_count_type_title = UIUtils.IProp2Str((o: IBrandGwsGameProviderSegmentationListItem) => { o.treshold_dep_count_type_title });
        public readonly dk_treshold_deposit_count = UIUtils.IProp2Str((o: IBrandGwsGameProviderSegmentationListItem) => { o.treshold_deposit_count });
        public readonly dk_is_treshold_deposit_count = UIUtils.IProp2Str((o: IBrandGwsGameProviderSegmentationListItem) => { o.is_treshold_deposit_count });
    
        public readonly dk_treshold_inout_percent_x100 = UIUtils.IProp2Str((o: IBrandGwsGameProviderSegmentationListItem) => { o.treshold_inout_percent_x100 });
        public readonly dk_treshold_inout_percent_type_code = UIUtils.IProp2Str((o: IBrandGwsGameProviderSegmentationListItem) => { o.treshold_inout_percent_type_code });
        public readonly dk_treshold_inout_percent_type_title = UIUtils.IProp2Str((o: IBrandGwsGameProviderSegmentationListItem) => { o.treshold_inout_percent_type_title });
        public readonly dk_is_treshold_inout_percent = UIUtils.IProp2Str((o: IBrandGwsGameProviderSegmentationListItem) => { o.is_treshold_inout_percent });
    
        public readonly dk_treshold_bonus_level_id = UIUtils.IProp2Str((o: IBrandGwsGameProviderSegmentationListItem) => { o.treshold_bonus_level_id });
        public readonly dk_treshold_bonus_level_title = UIUtils.IProp2Str((o: IBrandGwsGameProviderSegmentationListItem) => { o.treshold_bonus_level_title });
        public readonly dk_treshold_bonus_level_type_code = UIUtils.IProp2Str((o: IBrandGwsGameProviderSegmentationListItem) => { o.treshold_bonus_level_type_code });
        public readonly dk_treshold_bonus_level_type_title = UIUtils.IProp2Str((o: IBrandGwsGameProviderSegmentationListItem) => { o.treshold_bonus_level_type_title });
        public readonly dk_is_treshold_bonus_level = UIUtils.IProp2Str((o: IBrandGwsGameProviderSegmentationListItem) => { o.is_treshold_bonus_level });
        */
        _this.dk_player_profit_status_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_profit_status_code; });
        _this.dk_player_profit_status_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_profit_status_title; });
        _this.dk_custom_gameprovider_zone_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.custom_gameprovider_zone_id; });
        _this.dk_custom_gameprovider_zone_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.custom_gameprovider_zone_title; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    BrandGwsGameProviderSegmentationListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    BrandGwsGameProviderSegmentationListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    BrandGwsGameProviderSegmentationListCtl.prototype.LoadData = function (brandGwsGameProviderId, onDone) {
        var _this = this;
        webAApi_1.ListBrandGwsSegmentationGet.exec({
            brand_gws_gameprovider_id: brandGwsGameProviderId
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    /*
                    treshold_rtp_type_code: resp.list[i].treshold_rtp_type_code,
                    treshold_rtp_type_title: resp.list[i].treshold_rtp_type_title,
                    treshold_rtp_x100: resp.list[i].treshold_rtp_x100,
                    is_treshold_rtp: resp.list[i].is_treshold_rtp,

                    treshold_dep_count_type_code: resp.list[i].treshold_dep_count_type_code,
                    treshold_dep_count_type_title: resp.list[i].treshold_dep_count_type_title,
                    treshold_deposit_count: resp.list[i].treshold_deposit_count,
                    is_treshold_deposit_count: resp.list[i].is_treshold_deposit_count,

                    treshold_inout_percent_x100: resp.list[i].treshold_inout_percent_x100,
                    treshold_inout_percent_type_code: resp.list[i].treshold_inout_percent_type_code,
                    treshold_inout_percent_type_title: resp.list[i].treshold_inout_percent_type_title,
                    is_treshold_inout_percent: resp.list[i].is_treshold_inout_percent,

                    treshold_bonus_level_id: resp.list[i].treshold_bonus_level_id,
                    treshold_bonus_level_title: resp.list[i].treshold_bonus_level_title,
                    treshold_bonus_level_type_code: resp.list[i].treshold_bonus_level_type_code,
                    treshold_bonus_level_type_title: resp.list[i].treshold_bonus_level_type_title,
                    is_treshold_bonus_level: resp.list[i].is_treshold_bonus_level,
                    */
                    player_profit_status_code: resp.list[i].player_profit_status_code,
                    player_profit_status_title: resp.list[i].player_profit_status_title,
                    custom_gameprovider_zone_id: resp.list[i].custom_gameprovider_zone_id,
                    custom_gameprovider_zone_title: resp.list[i].custom_gameprovider_zone_title,
                    description: resp.list[i].description,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandGwsGameProviderSegmentationListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBrandGwsGameproviderSegmentation.exec({
            data: {
                brand_gws_gameprovider_id: data.brand_gws_gameprovider_id,
                /*treshold_rtp_type_code: data.treshold_rtp_type_code,
                treshold_rtp_x100: data.treshold_rtp_x100,
                is_treshold_rtp: data.is_treshold_rtp,

                treshold_dep_count_type_code: data.treshold_dep_count_type_code,
                treshold_deposit_count: data.treshold_deposit_count,
                is_treshold_deposit_count: data.is_treshold_deposit_count,

                treshold_inout_percent_x100: data.treshold_inout_percent_x100,
                treshold_inout_percent_type_code: data.treshold_inout_percent_type_code,
                is_treshold_inout_percent: data.is_treshold_inout_percent,

                treshold_bonus_level_id: data.treshold_bonus_level_id,
                treshold_bonus_level_type_code: data.treshold_bonus_level_type_code,
                is_treshold_bonus_level: data.is_treshold_bonus_level,*/
                player_profit_status_code: data.player_profit_status_code,
                custom_gameprovider_zone_id: data.custom_gameprovider_zone_id,
                description: data.description,
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                /*
                treshold_rtp_type_code: data.treshold_rtp_type_code,
                treshold_rtp_type_title: resp.treshold_rtp_type_title,
                treshold_rtp_x100: data.treshold_rtp_x100,
                is_treshold_rtp: data.is_treshold_rtp,

                treshold_dep_count_type_code: data.treshold_dep_count_type_code,
                treshold_dep_count_type_title: resp.treshold_dep_count_type_title,
                treshold_deposit_count: data.treshold_deposit_count,
                is_treshold_deposit_count: data.is_treshold_deposit_count,

                treshold_inout_percent_x100: data.treshold_inout_percent_x100,
                treshold_inout_percent_type_code: data.treshold_inout_percent_type_code,
                treshold_inout_percent_type_title: resp.treshold_inout_percent_type_title,
                is_treshold_inout_percent: data.is_treshold_inout_percent,

                treshold_bonus_level_id: data.treshold_bonus_level_id,
                treshold_bonus_level_title: resp.treshold_bonus_level_title,
                treshold_bonus_level_type_code: data.treshold_bonus_level_type_code,
                treshold_bonus_level_type_title: resp.treshold_bonus_level_type_title,
                is_treshold_bonus_level: data.is_treshold_bonus_level,
                */
                player_profit_status_code: data.player_profit_status_code,
                player_profit_status_title: resp.player_profit_status_title,
                custom_gameprovider_zone_id: data.custom_gameprovider_zone_id,
                custom_gameprovider_zone_title: resp.custom_gameprovider_zone_title,
                description: data.description,
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                date_changed2: moment(resp.date_added_uts_ms).utc(false)
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandGwsGameProviderSegmentationListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBrandGwsGameProviderSegmentation.exec({
                data: {
                    brands_gws_gameprovider_segmentation_id: data.key,
                    /*treshold_rtp_type_code: data.treshold_rtp_type_code,
                    treshold_rtp_x100: data.treshold_rtp_x100,
                    is_treshold_rtp: data.is_treshold_rtp,
                    treshold_dep_count_type_code: data.treshold_dep_count_type_code,
                    treshold_deposit_count: data.treshold_deposit_count,
                    is_treshold_deposit_count: data.is_treshold_deposit_count,
                    treshold_inout_percent_x100: data.treshold_inout_percent_x100,
                    treshold_inout_percent_type_code: data.treshold_inout_percent_type_code,
                    is_treshold_inout_percent: data.is_treshold_inout_percent,
                    treshold_bonus_level_id: data.treshold_bonus_level_id,
                    treshold_bonus_level_type_code: data.treshold_bonus_level_type_code,
                    is_treshold_bonus_level: data.is_treshold_bonus_level,*/
                    player_profit_status_code: data.player_profit_status_code,
                    custom_gameprovider_zone_id: data.custom_gameprovider_zone_id,
                    description: data.description
                }
            }, function (resp) {
                /*_tmp.treshold_rtp_type_code = data.treshold_rtp_type_code;
                _tmp.treshold_rtp_type_title = resp.treshold_rtp_type_title;
                _tmp.treshold_rtp_x100 = data.treshold_rtp_x100;
                _tmp.is_treshold_rtp = data.is_treshold_rtp;

                _tmp.treshold_dep_count_type_code = data.treshold_dep_count_type_code;
                _tmp.treshold_dep_count_type_title = resp.treshold_dep_count_type_title;
                _tmp.treshold_deposit_count = data.treshold_deposit_count;
                _tmp.is_treshold_deposit_count = data.is_treshold_deposit_count;

                _tmp.treshold_inout_percent_x100 = data.treshold_inout_percent_x100;
                _tmp.treshold_inout_percent_type_code = data.treshold_inout_percent_type_code;
                _tmp.treshold_inout_percent_type_title = resp.treshold_inout_percent_type_title;
                _tmp.is_treshold_inout_percent = data.is_treshold_inout_percent;

                _tmp.treshold_bonus_level_id = data.treshold_bonus_level_id;
                _tmp.treshold_bonus_level_title = resp.treshold_bonus_level_title;
                _tmp.treshold_bonus_level_type_code = data.treshold_bonus_level_type_code;
                _tmp.treshold_bonus_level_type_title = resp.treshold_bonus_level_type_title;
                _tmp.is_treshold_bonus_level = data.is_treshold_bonus_level;*/
                _tmp.player_profit_status_code = data.player_profit_status_code;
                _tmp.player_profit_status_title = resp.player_profit_status_title;
                _tmp.custom_gameprovider_zone_id = data.custom_gameprovider_zone_id;
                _tmp.custom_gameprovider_zone_title = resp.custom_gameprovider_zone_title;
                _tmp.description = data.description;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandGwsGameProviderSegmentationListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    BrandGwsGameProviderSegmentationListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBrandGwsGameproviderSegmentation.exec({
                data: {
                    brands_gws_gameprovider_segmentation_id: key,
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return BrandGwsGameProviderSegmentationListCtl;
}(BaseController_1.BaseController));
exports.BrandGwsGameProviderSegmentationListCtl = BrandGwsGameProviderSegmentationListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ctl/gateways/BrandGwsGameProviderSegmentationListCtl.ts
// module id = 1039
// module chunks = 0